<template>
  <div>
    <carousel :perPage="1" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <p>They sit in the corner of the coffee shop, leaning into each other, his hand on hers.
          They lookup for a moment at a group of closterers passing the window, he whispers something in her ear and they both laugh. She pulls a folded piece of paper from her pocket and shows it to him, he smiles.
          </p>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <p>
          - hey, sorry, my mouth was at the bottom of my bag<br>
          - no problem, have you picked him up already?<br>
          - no, Suzie's picking him up today remember<br>
          - oh sorry, i forgot, yes . . why is that again?<br>
          - oh, you're such an idiot . . <br>
          - yes, it's been said<br>
          - i'm going to check out the place for his birthday party, don't want to ruin the surprise<br>
          - yes, yes, sorry, you told me you were doing that today<br>
          - are you finished with work?<br>
          - yes, want me to meet you en route?<br>
          - yes, meet me on the ribbon way <br>
          - like always<br>
          - yes, like always<br>
          </p>
        </div>
      </slide>
      <slide>
        <div class="padding">

          <p>The seeshaw's engine kicks into life again and the spray from the water is caught by the wind. The three of them sit in silence, their bodies swaying in sync as they turn the bend by the old flowtunnel entrance. Up ahead there is a group of people gathered by the shore. The rider slows the engine, their wake becoming just ripples.<br>
          - what are they doing?<br>
          - they're saying goodbye to someone bear<br>
          - who is leaving?<br>
          - well, someone has already left actually<br>
          - will they come back?<br>
          - would you like to explain this to him?<br>
          - ok, i guess it's my turn. Well you see bear, sometimes people go and then they don't come back<br>
          - never?<br>
          - yes, never<br>
          - so the people at the water aren't waiting<br>
          - no, they're remembering<br>
          </p>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <p>A child sits alone in a park, his feet dangling over the edge of a bench. Sunlight dapples through tree blossom.
          He's talking into his hands, quietly and then opening them, sending the words out into the air.<br></p>
          <p>Around him, the world has resumed. Cyclists sweep past him, couples walk hand in hand.<br>
          There's a group of people by the edge of the grass, standing in a circle, the sound of their singing caught on the wind.
          By the fountain there's a girl who looks lost and out of place. In the distance a woman reaches into her coat pocket.
          A waiter sits smoking on the steps at the back of a bar, he nods as the chef joins him on the step.
          The hall clock chimes and then the hubub of the city seems to fade for an instant. Somewhere there is a moment of tenderness, and a moment of loss.</p><br>
          <p>An elderly woman, her hands knotted around a wooden walking stick, approaches the bench and carefully takes a seat beside him. She smiles at the child, gently, and asks if he is alone, asks where his parents might be.</p><br>
          <p>The child smiles back, and by way of an answer, makes a square with the thumb and forefinger of each hand. Ink smudged fingertips joining at either corner.</p><br>
          <p>He stares intently through the square, and slowly moves his hands from left to right, scanning his surroundings.</p><br>
          <p>He frowns for a moment, and then fixes his gaze. His eyes shine brightly. The woman asks him what he can see, and he smiles up at her.</p><br>
          <p>The woman leans toward him, and the two of them sit there, listening to a sound from somewhere else.</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Hands'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
